import api from './store/api'

export const routes = [
  {
    path: '/', name: 'index', component: require('./pages/Main')
  },

  {
    path: '/login', name: 'login', component: require('./pages/Login')
  },

  {
    path: '/user',
    name: 'user',
    component: {
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: 'logout',
        name: 'logout',
        component: {
          created () {
            this.$store.dispatch('logout')
              .then(() => {
                this.$router.push('/')
              })
          }
        }
      },
      {
        path: 'token',
        component: {
          created () {
            api.Account
              .TemporaryToken()
              .then((response) => {
                console.log(encodeURIComponent(response.data.data))
              })
          }
        }
      },
      { path: 'password', component: require('./pages/Password') }
    ],
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/LoginByToken/:username/:token/:lessonId',
    component: {
      mounted () {
        console.log(this.$route.params.token)
        this.$store.dispatch('LoginByToken', { username: this.$route.params.username, loginToken: decodeURIComponent(this.$route.params.token) })
          .then((response) => {
            if (response.data.access_token !== '') {
              this.$store.commit('login', response.data)
              this.$router.push('/Lesson/' + this.$route.params.lessonId)
            } else {
              this.$router.push('/login')
            }
          })
      }
    },
    meta: {
      requiresAuth: false
    }
  },

  {
    path: '/LoginByToken/:username/:token/ref/:ref',
    component: {
      mounted () {
        console.log(this.$route.params.token)
        this.$store.dispatch('LoginByToken', { username: this.$route.params.username, loginToken: decodeURIComponent(this.$route.params.token) })
          .then((response) => {
            if (response.data.access_token !== '') {
              this.$store.commit('login', response.data)
              this.$router.push(decodeURIComponent(this.$route.params.ref))
            } else {
              this.$router.push('/login')
            }
          })
      }
    },
    meta: {
      requiresAuth: false
    }
  },

  {
    path: '/lessons',
    name: 'lessons',
    component: {
      template: '<router-view></router-view>'
    },
    children: [
      { path: '', name: 'lesson.list', component: require('./pages/Lessons') },
      { path: 'play/:lessonId', name: 'lesson.player', component: require('./pages/LessonPlayer') },
      { path: 'history', name: 'lesson.history', component: require('./pages/History') }
    ],
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/lesson/:lessonId', name: 'lesson.player2', component: require('./pages/LessonPlayer')
  },

  {
    path: '/works',
    name: 'works',
    component: {
      template: '<router-view></router-view>'
    },
    children: [
      { path: '', redirect: { name: 'works.list' } },
      { path: ':workId?', name: 'works.list', component: require('./pages/Works') }
    ],
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/exams',
    name: 'exams',
    component: {
      template: '<router-view></router-view>'
    },
    children: [
      { path: '', name: 'exams.list', component: require('./pages/Exams') },
      { path: 'start/:examId', name: 'exams.player', component: require('./pages/ExamPlayer') }
    ],
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/course-mgr',
    name: 'course-mgr',
    component: {
      template: '<router-view></router-view>'
    },
    children: [
      { path: '', name: 'course-mgr.index', component: require('./pages/Teacher/TeachingCourse') },
      { path: 'add/course', name: 'course-mgr.add', component: require('./pages/Teacher/TeachingCourseEditor') },
      { path: 'edit/:courseId', name: 'course-mgr.edit', component: require('./pages/Teacher/TeachingCourseEditor') },
      { path: 'attachment/:courseId', name: 'course-mgr.attachment', component: require('./pages/Teacher/TeachingCourseAttachment') },
      { path: 'assign/:courseId', name: 'course-mgr.assign', component: require('./pages/Teacher/TeachingCourseAssign') }
    ],
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/exam-mgr',
    name: 'exam-mgr',
    component: {
      template: '<router-view></router-view>'
    },
    children: [
      { path: '', name: 'exam-mgr.index', component: require('./pages/Teacher/TeachingExam') },
      { path: 'add/exam', name: 'exam-mgr.add', component: require('./pages/Teacher/TeachingExamEditor') },
      { path: 'edit/:examId', name: 'exam-mgr.edit', component: require('./pages/Teacher/TeachingExamEditor') },
      { path: 'assign/:examId', name: 'exam-mgr.assign', component: require('./pages/Teacher/TeachingExamAssign') }
    ],
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/group-mgr',
    name: 'group-mgr',
    component: {
      template: '<router-view></router-view>'
    },
    children: [
      { path: '', name: 'group-mgr.index', component: require('./pages/Teacher/TeachingGroup') },
      { path: 'add/group', name: 'group-mgr.add', component: require('./pages/Teacher/TeachingGroupEditor') },
      { path: 'edit/:groupId', name: 'group-mgr.edit', component: require('./pages/Teacher/TeachingGroupEditor') },
      { path: 'group/:groupId/student/add', name: 'group-mgr.student.add', component: require('./pages/Teacher/TeachingGroupAddStudent') },
      { path: 'group/:groupId/student/excel', name: 'group-mgr.student.excel', component: require('./pages/Teacher/TeachingGroupAddStudentByExcel') }
    ],
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/record-mgr',
    name: 'record-mgr',
    component: {
      template: '<router-view></router-view>'
    },
    children: [
      { path: '', name: 'record-mgr.index', component: require('./pages/Teacher/TeachingGroupRecord') },
      { path: 'work/:groupId', name: 'record-mgr.courses', component: require('./pages/Teacher/TeachingGroupRecord') },
      { path: 'work/:groupId/course/:courseId', name: 'record-mgr.course-students', component: require('./pages/Teacher/TeachingGroupRecord') },
      { path: 'work/course/:courseId/student/:studentId', name: 'record-mgr.student-lessons', component: require('./pages/Teacher/TeachingGroupRecord') },
      { path: 'exam/:groupId', name: 'record-mgr.exams', component: require('./pages/Teacher/TeachingGroupRecord') },
      { path: 'exam/:groupId/course/:courseId', name: 'record-mgr.exam-students', component: require('./pages/Teacher/TeachingGroupRecord') }
    ],
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/quiz',
    name: 'quiz',
    component: {
      template: '<router-view></router-view>'
    },
    children: [
      { path: '', name: 'quiz.index', component: require('./pages/Quiz') },
      { path: 'start', name: 'quiz.start', component: require('./pages/ExamPlayer') }
    ],
    meta: {
      requiresAuth: true
    }
  },

  { path: '*', redirect: { name: 'index' } }
]



// WEBPACK FOOTER //
// ./src/routes.js